export default __webpack_public_path__ + "static/media/Arrow - Right 1.9f01041c.svg";